import React from 'react';

const PartnersSection = () => {
  return (
    <section className="py-8 bg-white border-y border-[#E5E0DA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center gap-6">
          <div className="h-px flex-1 max-w-[100px] bg-gradient-to-r from-transparent to-[#E5E0DA]"></div>
          <div className="text-center">
            <p 
              className="text-[10px] tracking-[0.3em] uppercase mb-1"
              style={{ color: '#DE92A9' }}
            >
              PROUDLY PUBLISHED BY
            </p>
            <a
              href="https://www.independent.com.mt/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-70 transition-opacity inline-block"
              data-testid="malta-independent-link"
            >
              <span 
                className="text-xl md:text-2xl font-medium"
                style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
              >
                The Malta Independent
              </span>
            </a>
          </div>
          <div className="h-px flex-1 max-w-[100px] bg-gradient-to-l from-transparent to-[#E5E0DA]"></div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
